import PropTypes from 'prop-types';

export const badgePropTypes = {
	badgeClasses: PropTypes.arrayOf(PropTypes.string),
	// data-* attributes from WIS (BadgeSummary.dataAttributes); keys arrive un-prefixed.
	dataAttributes: PropTypes.objectOf(PropTypes.string),
	target: PropTypes.string,
	href: PropTypes.string,
	imageSrc: PropTypes.string.isRequired,
	imageAlt: PropTypes.string.isRequired,
	imageTitle: PropTypes.string,
	tooltip: PropTypes.string,
	disclaimer: PropTypes.string
};

export const badgeDefaultProps = {
	badgeClasses: [],
	dataAttributes: {},
	disclaimer: '',
	href: null,
	target: null,
	imageTitle: '',
	tooltip: ''
};
